import { createSlice } from "@reduxjs/toolkit";
import { addServiceException, addUser, assocOtherProducts, changePass, changeUserStatus, removeServiceException, searchUserActGrid, serviceExceptionList, subscribedProduct, userActGrid, userServiceList } from "../../actions/security/UserAccountMgmtAction";

const initialState = {
    loading: false,
    userTblData: null,
    error: null,
    success: false,
    //app service
    loading1: false,
    appServiceData: null,
    error1: null,
    success1: false,
    //service exception
    loading2: false,
    exceptionServiceData: null,
    error2: null,
    success2: false,
    //add service
    loading3: false,
    addServiceInfo: null,
    error3: null,
    success3: false,
    //remove servie
    loading4: false,
    removeServiceInfo: null,
    error4: null,
    success4: false,
    //user status
    loading5: false,
    userStatusInfo: null,
    error5: null,
    success5: false,
    //add user
    loading6: false,
    addUserInfo: null,
    error6: null,
    success6: false,
    //change password
    loading7: false,
    passInfo: null,
    error7: null,
    success7: false,
    //search grid,
    loading8: false,
    userTblData1: null,
    error8: null,
    success8: false,
    //search grid,
    loading9: false,
    subsProductInfo: null,
    error9: null,
    success9: false,
    //associated other products,
    loading10: false,
    associatedProdInfo: null,
    error10: null,
    success10: false,
}

const userAccSlice = createSlice({
    name: "user-account-mgmt",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(userActGrid.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(userActGrid.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.userTblData = payload;
                state.success = true;
                state.error = null;
            })
            .addCase(userActGrid.rejected, (state, { paylaod }) => {
                state.loading = false;
                state.error = paylaod;
                state.success = false;
            })
            //app service
            .addCase(userServiceList.pending, (state) => {
                state.loading1 = true;
                state.error1 = null;
                state.success1 = false;
            })
            .addCase(userServiceList.fulfilled, (state, { payload }) => {
                state.loading1 = false;
                state.appServiceData = payload;
                state.success1 = true;
                state.error1 = null;
            })
            .addCase(userServiceList.rejected, (state, { paylaod }) => {
                state.loading1 = false;
                state.error1 = paylaod;
                state.success1 = false;
            })
            // service exception
            .addCase(serviceExceptionList.pending, (state) => {
                state.loading2 = true;
                state.error2 = null;
                state.success2 = false;
            })
            .addCase(serviceExceptionList.fulfilled, (state, { payload }) => {
                state.loading2 = false;
                state.exceptionServiceData = payload;
                state.success2 = true;
                state.error2 = null;
            })
            .addCase(serviceExceptionList.rejected, (state, { paylaod }) => {
                state.loading2 = false;
                state.error2 = paylaod;
                state.success2 = false;
            })
            //add exception service
            .addCase(addServiceException.pending, (state) => {
                state.loading3 = true;
                state.error3 = null;
                state.success3 = false;
            })
            .addCase(addServiceException.fulfilled, (state, { payload }) => {
                state.loading3 = false;
                state.addServiceInfo = payload;
                state.success3 = true;
                state.error3 = null;
            })
            .addCase(addServiceException.rejected, (state, { paylaod }) => {
                state.loading3 = false;
                state.error3 = paylaod;
                state.success3 = false;
            })
            //remove exception service
            .addCase(removeServiceException.pending, (state) => {
                state.loading4 = true;
                state.error4 = null;
                state.success4 = false;
            })
            .addCase(removeServiceException.fulfilled, (state, { payload }) => {
                state.loading4 = false;
                state.removeServiceInfo = payload;
                state.success4 = true;
                state.error4 = null;
            })
            .addCase(removeServiceException.rejected, (state, { paylaod }) => {
                state.loading4 = false;
                state.error4 = paylaod;
                state.success4 = false;
            })
            //changeStatus
            .addCase(changeUserStatus.pending, (state) => {
                state.loading5 = true;
                state.error5 = null;
                state.success5 = false;
            })
            .addCase(changeUserStatus.fulfilled, (state, { payload }) => {
                state.loading5 = false;
                state.userStatusInfo = payload;
                state.success5 = true;
                state.error5 = null;
            })
            .addCase(changeUserStatus.rejected, (state, { paylaod }) => {
                state.loading5 = false;
                state.error5 = paylaod;
                state.success5 = false;
            })
            //add user
            .addCase(addUser.pending, (state) => {
                state.loading6 = true;
                state.error6 = null;
                state.success6 = false;
            })
            .addCase(addUser.fulfilled, (state, { payload }) => {
                state.loading6 = false;
                state.addUserInfo = payload;
                state.success6 = true;
                state.error6 = null;
            })
            .addCase(addUser.rejected, (state, { paylaod }) => {
                state.loading6 = false;
                state.error6 = paylaod;
                state.success6 = false;
            })
            //change password
            .addCase(changePass.pending, (state) => {
                state.loading7 = true;
                state.error7 = null;
                state.success7 = false;
            })
            .addCase(changePass.fulfilled, (state, { payload }) => {
                state.loading7 = false;
                state.passInfo = payload;
                state.success7 = true;
                state.error7 = null;
            })
            .addCase(changePass.rejected, (state, { paylaod }) => {
                state.loading7 = false;
                state.error7 = paylaod;
                state.success7 = false;
            })
            //search user account
            .addCase(searchUserActGrid.pending, (state) => {
                state.loading8 = true;
                state.error8 = null;
                state.success8 = false;
            })
            .addCase(searchUserActGrid.fulfilled, (state, { payload }) => {
                state.loading8 = false;
                state.userTblData1 = payload;
                state.success8 = true;
                state.error8 = null;
            })
            .addCase(searchUserActGrid.rejected, (state, { paylaod }) => {
                state.loading8 = false;
                state.error8 = paylaod;
                state.success8 = false;
            })
            //subscribed product
            .addCase(subscribedProduct.pending, (state) => {
                state.loading9 = true;
                state.error9 = null;
                state.success9 = false;
            })
            .addCase(subscribedProduct.fulfilled, (state, { payload }) => {
                state.loading9 = false;
                state.subsProductInfo = payload;
                state.success9 = true;
                state.error9 = null;
            })
            .addCase(subscribedProduct.rejected, (state, { paylaod }) => {
                state.loading9 = false;
                state.error9 = paylaod;
                state.success9 = false;
            })
             //associated other product
             .addCase(assocOtherProducts.pending, (state) => {
                state.loading10 = true;
                state.error10 = null;
                state.success10 = false;
            })
            .addCase(assocOtherProducts.fulfilled, (state, { payload }) => {
                state.loading10= false;
                state.associatedProdInfo = payload;
                state.success10= true;
                state.error10 = null;
            })
            .addCase(assocOtherProducts.rejected, (state, { paylaod }) => {
                state.loading10 = false;
                state.error10 = paylaod;
                state.success10 = false;
            })
    }
});

export default userAccSlice.reducer;